module.exports = __webpack_public_path__ + "img/1330.b5e38da8.gif";